import { useEffect, useReducer } from 'react'
import { history, useTypedSelector } from '../../redux/store'
import { message } from 'antd'
import { useDispatch } from 'react-redux'
import { fileFile } from '../../modules/uploadfiles/hooks'
import { useSkipInitEffect } from '../../tools/utilHooks'
import { setModuleDataAction } from '../../modules/pagecache'
import { invoicingType, isResponseCodeSuccess } from '../../tools/util'
import { useLocation } from 'react-router-dom'
import {
  BATCH_GET_ORDER_PRODUCT_INFO,
  DOWNLOAD_ZIP_MORE,
  GET_ORDER_DETAIL_BY_APPLICATION_NUM,
  GET_ORDER_INVOICE_DETAIL,
} from '../../api/orderManage'
import copy from 'copy-to-clipboard'
import reducer, {
  RouteParams,
  initialState,
  reloadStateAction,
  setInvoiceInfoDataAction,
  setInvoiceTypeAction,
  setInvoicingInfoAction,
  setIsPreviewModalVisibleAction,
  setMaterialDataAction,
  setOrderDataAction,
  setPreviewFileUrlAction,
  setRouteParamsAction,
} from './reducer'
import { Form } from 'antd'
import { OrderInvoiceParams } from './reducer'

interface FormValues extends OrderInvoiceParams {
  province?: string
  city?: string
  provinceCode?: string
  cityCode?: string
}

export type FieldType = {
  province?: string
  city?: string
  provinceCode?: string
  cityCode?: string
  // 其他字段...
}

export const PROVINCE_MAP: Record<string, string> = {
  北京: '110000',
  上海: '310000',
  广州: '440000',
}

export const CITY_MAP: Record<string, string> = {
  北京市: '110100',
  上海市: '310100',
  广州市: '440100',
}

export default function useInvoiceApplicationDetailHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { routeParams, invoicingInfo } = state
  const dispatchredux = useDispatch()
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const location = useLocation<RouteParams>()
  const { state: routeState } = location
  const CACHE_KEY = history.location.pathname

  const [form] = Form.useForm()
  // 使用 onFieldsChange 获取字段变化
  const handleFieldsChange = (
    changedFields: Array<{
      name: (string | number)[]
      value: any
      touched?: boolean
    }>,
  ) => {
    const provinceField = changedFields.find((f) => f.name.includes('province'))
    const cityField = changedFields.find((f) => f.name.includes('city'))

    if (provinceField || cityField) {
      const values = form.getFieldsValue()
      const { province, city } = values

      const newProvinceCode = PROVINCE_MAP[province] || ''
      const newCityCode = CITY_MAP[city] || ''

      form.setFieldsValue({
        provinceCode: newProvinceCode,
        cityCode: newCityCode,
      })
    }
  }

  // 表单提交逻辑
  const onFinish = async (values: FormValues) => {
    console.log('提交数据:', values)
  }

  useEffect(() => {
    const flag = getpagecache()
    if (flag && !routeState) {
      const action = reloadStateAction(flag)
      dispatch(action)
      getDetailInfo(flag.routeParams.orderId)
    } else if (routeState) {
      dispatch(setRouteParamsAction(routeState))
      getOrderDetailInfo(routeState.applicationNumber)
      getDetailInfo(routeState.orderId)
    }
  }, [])

  useSkipInitEffect(() => {
    // 缓存存数据
    const action = setModuleDataAction({
      key: CACHE_KEY,
      data: state,
    })
    dispatchredux(action)
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const data = pagekey.filter((item) => item.key === CACHE_KEY)
    return data.length === 1 ? data[0].data : null
  }

  // 获取详情
  const getDetailInfo = async (id?: string) => {
    const res = await GET_ORDER_INVOICE_DETAIL({
      orderInvoiceId: id || routeParams.orderId,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      dispatch(setInvoicingInfoAction(resData))
      dispatch(setInvoiceInfoDataAction(resData.openInvoiceList))
      dispatch(setInvoiceTypeAction(resData.invoiceType))
    }
  }

  // 复制
  const onCopy = (type: 'invoice' | 'address') => {
    let template = ''
    let msgTitle = ''
    switch (type) {
      case 'invoice':
        template = `发票类型：${
          invoicingType.find(
            (item) => item.value === invoicingInfo?.orderInvoiceEnums,
          )?.name
        }\n发票抬头：${invoicingInfo?.title}\n税号：${invoicingInfo?.taxNumber}\n开户银行：${invoicingInfo?.bankName}\n银行账户：${invoicingInfo?.bankAccount}\n电话：${invoicingInfo?.mobile}\n地址：${invoicingInfo?.address}\n票面信息：${invoicingInfo?.content}`
        msgTitle = '发票抬头'
        break
      case 'address':
        template = `收件人：${invoicingInfo?.receiveMan}\n联系电话：${invoicingInfo?.receiveMobile}\n收件地址：${invoicingInfo?.receiveAddress}\n其他备注：${invoicingInfo?.remark}`
        msgTitle = '收件地址'
        break
    }
    copy(template)
    message.success(`复制${msgTitle}成功`)
  }

  // 获取订单详情
  const getOrderDetailInfo = async (applicationNumber: string) => {
    const res = await GET_ORDER_DETAIL_BY_APPLICATION_NUM({
      applicationNumber,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      dispatch(setOrderDataAction(resData))
      const resList = await BATCH_GET_ORDER_PRODUCT_INFO({
        orderIds: resData.map((item) => item.id).join(','),
      })
      if (isResponseCodeSuccess(resList.code)) {
        const list = resList.data
          .map((item) => {
            return item.productDetailVO.map((i) => {
              return {
                ...i,
                orderNo: item.orderNo,
              }
            })
          })
          .flat()
        dispatch(setMaterialDataAction(list))
      } else {
        message.warning(res.msg)
      }
    } else {
      message.warning(res.msg)
    }
  }

  // 打包下载附件
  const onPackageDownload = async (files: fileFile[]) => {
    await DOWNLOAD_ZIP_MORE({
      fileIdList: files.map((item) => item.id!),
    })
  }

  const cancelPreviewModal = () => {
    dispatch(setIsPreviewModalVisibleAction(false))
  }

  const showPreviewModal = (url: string) => {
    dispatch(setPreviewFileUrlAction(url))
    dispatch(setIsPreviewModalVisibleAction(true))
  }

  return {
    handleFieldsChange,
    form,
    onFinish,
    hookstate: state,
    onCopy,
    onPackageDownload,
    showPreviewModal,
    cancelPreviewModal,
  }
}
import { useEffect, useReducer } from 'react'
import { history, useTypedSelector } from '../../redux/store'
import { message } from 'antd'
import { useDispatch } from 'react-redux'
import { fileFile } from '../../modules/uploadfiles/hooks'
import { useSkipInitEffect } from '../../tools/utilHooks'
import { setModuleDataAction } from '../../modules/pagecache'
import { invoicingType, isResponseCodeSuccess } from '../../tools/util'
import { useLocation } from 'react-router-dom'
import {
  BATCH_GET_ORDER_PRODUCT_INFO,
  DOWNLOAD_ZIP_MORE,
  GET_ORDER_DETAIL_BY_APPLICATION_NUM,
  GET_ORDER_INVOICE_DETAIL,
} from '../../api/orderManage'
import copy from 'copy-to-clipboard'
import reducer, {
  RouteParams,
  initialState,
  reloadStateAction,
  setInvoiceInfoDataAction,
  setInvoiceTypeAction,
  setInvoicingInfoAction,
  setIsPreviewModalVisibleAction,
  setMaterialDataAction,
  setOrderDataAction,
  setPreviewFileUrlAction,
  setRouteParamsAction,
} from './reducer'
import { Form } from 'antd'
import { OrderInvoiceParams } from './reducer'

interface FormValues extends OrderInvoiceParams {
  province?: string
  city?: string
  provinceCode?: string
  cityCode?: string
}

export type FieldType = {
  province?: string
  city?: string
  provinceCode?: string
  cityCode?: string
  // 其他字段...
}

export const PROVINCE_MAP: Record<string, string> = {
  北京: '110000',
  上海: '310000',
  广州: '440000',
}

export const CITY_MAP: Record<string, string> = {
  北京市: '110100',
  上海市: '310100',
  广州市: '440100',
}

export default function useInvoiceApplicationDetailHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { routeParams, invoicingInfo } = state
  const dispatchredux = useDispatch()
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const location = useLocation<RouteParams>()
  const { state: routeState } = location
  const CACHE_KEY = history.location.pathname

  const [form] = Form.useForm()
  // 使用 onFieldsChange 获取字段变化
  const handleFieldsChange = (
    changedFields: Array<{
      name: (string | number)[]
      value: any
      touched?: boolean
    }>,
  ) => {
    const provinceField = changedFields.find((f) => f.name.includes('province'))
    const cityField = changedFields.find((f) => f.name.includes('city'))

    if (provinceField || cityField) {
      const values = form.getFieldsValue()
      const { province, city } = values

      const newProvinceCode = PROVINCE_MAP[province] || ''
      const newCityCode = CITY_MAP[city] || ''

      form.setFieldsValue({
        provinceCode: newProvinceCode,
        cityCode: newCityCode,
      })
    }
  }

  // 表单提交逻辑
  const onFinish = async (values: FormValues) => {
    console.log('提交数据:', values)
  }

  useEffect(() => {
    const flag = getpagecache()
    if (flag && !routeState) {
      const action = reloadStateAction(flag)
      dispatch(action)
      getDetailInfo(flag.routeParams.orderId)
    } else if (routeState) {
      dispatch(setRouteParamsAction(routeState))
      getOrderDetailInfo(routeState.applicationNumber)
      getDetailInfo(routeState.orderId)
    }
  }, [])

  useSkipInitEffect(() => {
    // 缓存存数据
    const action = setModuleDataAction({
      key: CACHE_KEY,
      data: state,
    })
    dispatchredux(action)
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const data = pagekey.filter((item) => item.key === CACHE_KEY)
    return data.length === 1 ? data[0].data : null
  }

  // 获取详情
  const getDetailInfo = async (id?: string) => {
    const res = await GET_ORDER_INVOICE_DETAIL({
      orderInvoiceId: id || routeParams.orderId,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      dispatch(setInvoicingInfoAction(resData))
      dispatch(setInvoiceInfoDataAction(resData.openInvoiceList))
      dispatch(setInvoiceTypeAction(resData.invoiceType))
    }
  }

  // 复制
  const onCopy = (type: 'invoice' | 'address') => {
    let template = ''
    let msgTitle = ''
    switch (type) {
      case 'invoice':
        template = `发票类型：${
          invoicingType.find(
            (item) => item.value === invoicingInfo?.orderInvoiceEnums,
          )?.name
        }\n发票抬头：${invoicingInfo?.title}\n税号：${invoicingInfo?.taxNumber}\n开户银行：${invoicingInfo?.bankName}\n银行账户：${invoicingInfo?.bankAccount}\n电话：${invoicingInfo?.mobile}\n地址：${invoicingInfo?.address}\n票面信息：${invoicingInfo?.content}`
        msgTitle = '发票抬头'
        break
      case 'address':
        template = `收件人：${invoicingInfo?.receiveMan}\n联系电话：${invoicingInfo?.receiveMobile}\n收件地址：${invoicingInfo?.receiveAddress}\n其他备注：${invoicingInfo?.remark}`
        msgTitle = '收件地址'
        break
    }
    copy(template)
    message.success(`复制${msgTitle}成功`)
  }

  // 获取订单详情
  const getOrderDetailInfo = async (applicationNumber: string) => {
    const res = await GET_ORDER_DETAIL_BY_APPLICATION_NUM({
      applicationNumber,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      dispatch(setOrderDataAction(resData))
      const resList = await BATCH_GET_ORDER_PRODUCT_INFO({
        orderIds: resData.map((item) => item.id).join(','),
      })
      if (isResponseCodeSuccess(resList.code)) {
        const list = resList.data
          .map((item) => {
            return item.productDetailVO.map((i) => {
              return {
                ...i,
                orderNo: item.orderNo,
              }
            })
          })
          .flat()
        dispatch(setMaterialDataAction(list))
      } else {
        message.warning(res.msg)
      }
    } else {
      message.warning(res.msg)
    }
  }

  // 打包下载附件
  const onPackageDownload = async (files: fileFile[]) => {
    await DOWNLOAD_ZIP_MORE({
      fileIdList: files.map((item) => item.id!),
    })
  }

  const cancelPreviewModal = () => {
    dispatch(setIsPreviewModalVisibleAction(false))
  }

  const showPreviewModal = (url: string) => {
    dispatch(setPreviewFileUrlAction(url))
    dispatch(setIsPreviewModalVisibleAction(true))
  }

  return {
    handleFieldsChange,
    form,
    onFinish,
    hookstate: state,
    onCopy,
    onPackageDownload,
    showPreviewModal,
    cancelPreviewModal,
  }
}
